import { useCallback } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { useOptionalWeekViewContext } from "../contexts/WeekView";
import { useFormatPersonName } from "./useNameFormat";
import { useRosterLookup } from "./useRosterLookup";

/**
 * A person's name as the staffing pages show it: from the week's own people, so a row is named before the roster
 * loads. Someone the week doesn't hold (a replacement from outside it), or any id outside the staffing pages, is
 * named from the roster.
 */
export const useSchedulePersonName = (): ((nurseId: number) => string) => {
	const getSchedulePerson = useOptionalWeekViewContext()?.getSchedulePerson;
	const { chosenDepartment } = useChosenDepartment();
	const { getNurseFormattedName } = useRosterLookup(chosenDepartment.department_id);
	const formatPersonName = useFormatPersonName();
	return useCallback(
		(nurseId: number): string => {
			const person = getSchedulePerson?.(nurseId);
			return person ? formatPersonName(person) : getNurseFormattedName(nurseId);
		},
		[getSchedulePerson, formatPersonName, getNurseFormattedName],
	);
};
